import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import WorkResourceModal from './WorkResourceModal'
import WorkAddWagollModal from './WorkAddWagollModal'

import axios from 'axios'
import Modal from 'react-modal'

import FaPlus from 'react-icons/fa/plus'
import FaScreen from 'react-icons/fa/desktop'
import FaInfo from 'react-icons/fa/info-circle'

import { SubscriptionPolicy } from 'pobble-components/dist/subscriptions'

@autobind
class WorkResources extends Component {
  constructor (props) {
    super(props)
    this.state = {showResourceModal: false, showWagollModal: false}
  }

  componentWillMount () {
    // this.getResources()
    Modal.setAppElement('body')
  }

  getResources () {
    return axios.get(`/api/v1/lessons/${this.props.lesson.id}/teaching_resources.json`)
      .then(({data}) => {
        this.setState({resources: data.teaching_resources})
        this.getLessons()
      }).catch(err => err.response.status !== 401 && err)
  }

  getLessons () {
    return axios.get(`/teacher/lessons.json`)
      .then(({data}) => {
        this.setState({lessons: data.lessons.filter(lesson => !lesson.delivered)})
      })
  }

  handleOpenResourceModal (index) {
    this.setState({showResourceModal: true, resource: this.state.resources[index]})
  }

  handleCloseResourceModal () {
    this.setState({showResourceModal: false})
  }

  handleOpenWagollModal () {
    this.setState({showWagollModal: true})
  }

  handleCloseWagollModal () {
    this.setState({showWagollModal: false})
  }

  render () {
    var resources = this.props.presentation && this.props.presentation.teaching_resources && this.props.presentation.teaching_resources.map((resource, index) =>
      <li key={resource.id}>
        <a href={`/resources/external/${resource.source_type_key}/${resource.external_id}`} className='wv__resource' rel='noopener noreferrer' target='_blank'>
          {resource.media_sources.length > 0 && resource.media_sources[0].original_media_url && <div className='wv__resource__image' style={{backgroundImage: `url(${resource.media_sources[0].original_media_url}`}} />}
          <div className='wv__resource__body'>
            <div className='wv__resource__title'>{resource.title}</div>
            <span className='wv__resource__source'>
              {resource.source_type}
            </span>
          </div>
        </a>
      </li>
    )

    var lessonsList = this.state.lessons && this.state.lessons.slice(0, 5).map((lesson, index) =>
      <li key={lesson.id}><a onClick={() => this.handleOpenWagollModal(this.props.id, index)}>{lesson.title}</a></li>
    )

    let studentName = this.props.student_type && this.props.student_type.display_name ? `${this.props.student_type.display_name}'` : 'this'

    return (
      <div>{this.props.user && this.props.user.policy && this.props.user.policy.can_use_presentations && <section className='WorkResources'>
        <label className='sidebar__folded__header'>
          <h4 className='sidebar__folded__title'>Start a lesson from here</h4>
        </label>
        <div className='wv__resource__container'>
          <div className='wv__resource__add'>
            <SubscriptionPolicy policy={sp => sp.lesson_planning.edit_presentation}>
              {editPresentationSp => (
                <button htmlFor='lessonsList' onClick={editPresentationSp.restricted ? editPresentationSp.showDialog : this.handleOpenWagollModal} className='btn btn-primary btn-block'><FaPlus/> Add this work to my presentation</button>
              )}
            </SubscriptionPolicy>
          </div>
          {this.props.presentation && this.props.presentation.public && <div className='wv__resource__add'>
            <a href={`/lessons/preview/${this.props.presentation.id}`} className='btn btn-default btn-block' rel='noopener noreferrer' target='_blank'><FaScreen/> Preview {this.props.presentation.account && this.props.presentation.account.display_name && this.props.presentation.account.display_name}'s presentation</a>
          </div>}
          {this.props.presentation && this.props.presentation.teaching_resources && this.props.presentation.teaching_resources.length > 0 && <div className='wv__resource__used'>
            <span>View {this.props.presentation.teaching_resources.length} teaching resource{this.props.presentation.teaching_resources.length > 1 ? 's' : ''}</span>
            <ul className='list-unstyled'>
              {resources}
            </ul>
          </div>}
        </div>
        <Modal isOpen={this.state.showResourceModal} contentLabel='Resource modal' onRequestClose={this.handleCloseResourceModal} overlayClassName='modal fade in' style={{content: {background: 'transparent', border: 'none'}}}>
          <WorkResourceModal resource={this.state.resource} lessons={this.state.lessons} onCloseModal={this.handleCloseResourceModal} />
        </Modal>
        <Modal isOpen={this.state.showWagollModal} contentLabel='Add to lesson modal' onRequestClose={this.handleCloseWagollModal} overlayClassName='modal fade in' style={{content: {background: 'transparent', border: 'none'}}}>
          <WorkAddWagollModal work={this.props} lesson={this.state.lesson} onCloseModal={this.handleCloseWagollModal} />
        </Modal>
      </section>}</div>
    )
  }
}

WorkResources.propTypes = {
  id: PropTypes.string,
  lesson: PropTypes.object
}

export default WorkResources



// WEBPACK FOOTER //
// ./components/work/WorkResources.js